import { SaveBar as ShopifySaveBar } from '@shopify/app-bridge-react';

export type SaveBarProps = {
  open: boolean;
  onSave: () => void;
  onDiscard: () => void;
  isDirty: boolean;
  isSaving?: boolean;
};

export default function SaveBar({ open, onSave, onDiscard, isDirty, isSaving }: SaveBarProps) {
  return (
    <ShopifySaveBar open={open}>
      <button variant="primary" onClick={onSave} disabled={!isDirty || isSaving}>
        {isSaving ? 'Saving…' : 'Save'}
      </button>
      <button onClick={onDiscard}>Discard</button>
    </ShopifySaveBar>
  );
}
